import { useTranslation } from 'react-i18next';
import ExoForm from '../exo/ExoForm';
import StarIcon from '@mui/icons-material/Star';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Box } from '@mui/material';
import Loader from '../special/Loader';
import { useState } from 'react';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import findDifferences from '../exo/findDifferencesInDataCollection';
import * as Yup from 'yup';

export const NewPersonLead = ({ onClose, onCreate, onUpdate, startData }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const fields = [
    {
      label: t('Salutation'),
      key: 'salutation',
      type: 'text',
    },
    {
      label: t('First Name'),
      key: 'firstName',
      type: 'text',
    },
    {
      label: t('Last Name'),
      key: 'lastName',
      type: 'text',
    },
    {
      label: t('Position'),
      key: 'position',
      type: 'text',
    },
    {
      label: t('Website'),
      key: 'url',
      type: 'text',
    },
    {
      label: t('Note'),
      key: 'note',
      type: 'richText',
    },
    {
      label: t('Responsible Employee'),
      key: 'responsibleUser',
      type: 'user',
    },
    {
      label: t('Address'),
      key: 'address',
      type: 'address',
    },
    {
      label: t('E-Mails'),
      type: 'nameValueArray',
      key: 'emails',
      addLabel: t('Add E-Mail'),
      nameKey: 'emailType',
      valueKey: 'emailAddress',
      placeholder: {
        name: t('Label'),
        value: t('E-Mail'),
      },
      radioItems: [
        {
          key: 'isPrimary',
          Icon: StarIcon,
          label: 'Favorite',
        },
        {
          key: 'isInvoiceMail',
          Icon: ReceiptIcon,
          label: 'Invoice E-Mail',
        },
      ],
    },
    {
      label: t('Phonenumbers'),
      type: 'nameValueArray',
      key: 'telephoneNumbers',
      addLabel: t('Add phonenumber'),
      nameKey: 'phoneType',
      valueKey: 'phoneNumber',
      placeholder: {
        name: t('Label'),
        value: t('Phonenumber'),
      },
      radioItems: [
        {
          key: 'isPrimary',
          Icon: StarIcon,
          label: 'Favorite',
        },
      ],
    },
    {
      label: t('Purchasing profile'),
      key: 'properties',
      type: 'salesOjectProperties',
    },
    {
      label: t('Lead Companies'),
      key: 'companies',
      type: 'leadCompanies',
    },
  ];

  const config = useConfig();

  function handleSubmit(data) {
    const newData = {
      ...findDifferences(startData, data),
      emails: data.emails,
    };

    DBRequest({
      config,
      path:
        startData && startData.id
          ? `leads/persons/${data.id}`
          : 'leads/persons',
      method: startData && startData.id ? API_PATCH(newData) : API_POST(data),
      onResponse: handleResponse,
      onFeedback: handleFeedback,
      onLoading: setIsLoading,
    });
  }

  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });

  function handleFeedback(text, type) {
    startData = setAlertState({
      alertOpen: true,
      alertText: text,
      alertType: type,
    });
  }

  function handleResponse(data) {
    onClose();
    if (startData && startData.id) {
      onUpdate(data);
    } else {
      onCreate(data);
    }
  }

  const phoneSchema = Yup.object().shape({
    phoneType: Yup.string().required('Is required'),
    phoneNumber: Yup.string().required('Is required'),
  });
  const emailSchema = Yup.object().shape({
    emailType: Yup.string().required('Is required'),
    emailAddress: Yup.string().required('Is required'),
  });

  const validationSchema = Yup.object().shape({
    salutation: Yup.string().required(t('Is required')),
    firstName: Yup.string().required(t('Is required')),
    lastName: Yup.string().required(t('Is required')),
    telephoneNumbers: Yup.array().of(phoneSchema).nullable(),
    emails: Yup.array().of(emailSchema).nullable(),
    responsibleUser: Yup.object().shape({
      id: Yup.number().required(t('Is required')),
    }),
  });
  return (
    <Box>
      <Loader active={isLoading} />
      <ExoForm
        fields={fields}
        header={t('New Lead Person')}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        onCancel={onClose}
        startDataCollection={startData}
        noDifferences
      />
    </Box>
  );
};
